export default "__VITE_ASSET__Igsy82S0__"